// Le Mug Fondue — logique de la boutique (navigation, produit, panier), sur la base du site Rosalia.
// Deux modes :
//  - thème Shopify (window.MF défini par layout/theme.liquid) : vrai panier /cart/*.js et vrai paiement /checkout ;
//  - fichier HTML autonome : panier local, puis paiement sur qavelynt.com via un lien panier Shopify.
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const euro = n => n.toFixed(2).replace('.', ',') + '€';
  const MF = window.MF || null;
  const STORE = 'https://qavelynt.com';
  const img = p => (MF ? MF.assets + p.replace('images/', '') : p);
  const pageUrl = h => (MF ? '/pages/' + h : '#/page/' + h);
  const productUrl = MF ? MF.productUrl : '#/produit';

  // Prix et variantes repris de la boutique Shopify (17 € le mug ; remises automatiques 2 mugs = 27 €, 4 mugs = 37 €)
  const PRODUCT = {
    title: 'Le Mug Fondue',
    images: ['images/produit-1.jpg', 'images/produit-2.jpg', 'images/produit-3.jpg', 'images/produit-4.jpg', 'images/produit-5.jpg', 'images/produit-6.jpg'],
    colors: [
      { name: 'Rouge', hex: '#c8102e', img: 0, variant: 59437488013644 },
      { name: 'Chocolat', hex: '#4a2c20', img: 5, variant: 59437488046412 },
      { name: 'Blanc', hex: '#f3eee6', img: 4, variant: 59437488079180 }
    ],
    packs: [
      { id: 'p1', qty: 1, emoji: '☕', name: '1 mug · Rien que pour moi', sub: 'Pour se faire plaisir', price: 17.00 },
      { id: 'p2', qty: 2, emoji: '💑', name: '2 mugs · En duo', sub: 'Livraison offerte · idéal à deux', price: 27.00, full: 34.00, badge: 'Le plus choisi' },
      { id: 'p4', qty: 4, emoji: '🎁', name: '4 mugs · Pack famille', sub: 'Livraison offerte · le meilleur prix', price: 37.00, full: 68.00, badge: 'Meilleur prix' }
    ]
  };
  if (MF && MF.variants) PRODUCT.colors.forEach(c => { if (MF.variants[c.name]) c.variant = MF.variants[c.name]; });

  const STEPS = [
    { t: 'Allumez la bougie', d: 'Glissez-la sous la tasse, posez le mug à plat.' },
    { t: 'Ajoutez le chocolat', d: 'Noir, lait ou blanc : quelques carrés suffisent.' },
    { t: 'Trempez et savourez', d: 'Fraises, banane, guimauves… il reste fondu.' }
  ];

  const INFOS = [
    ['📦 Dans le colis', '<p>1 mug fondue et 1 pique à fondue (rangée dans l’anse). <b>Bougie chauffe-plat non fournie</b> : n’importe quelle bougie du supermarché convient (Ø 4 cm max.).</p><p><b>Entretien :</b> laissez refroidir, lavez à la main à l’eau chaude savonneuse. Pas de lave-vaisselle ni de micro-ondes.</p>'],
    ['🔥 L’anse chauffe-t-elle ?', '<p>La flamme se trouve sous la tasse, loin de l’anse : vous pouvez tenir le mug par l’anse pendant la dégustation. Les parois, elles, deviennent chaudes : ne déplacez pas le mug quand la bougie est allumée.</p>'],
    ['🚚 Livraison', `<p><b>Préparée sous</b> environ 1 à 2 jours ouvrés, <b>livrée</b> en environ 6 à 9 jours ouvrés</p><p><b>Livraison suivie,</b> numéro de suivi par e-mail</p><p><b>Offerte en France</b> dès 1 mug</p><p>Union européenne 22 € · Autres pays 29 €</p><p><a href="${pageUrl('livraison')}">Conditions de livraison</a></p>`],
    ['↩️ Satisfait ou remboursé 30 jours', `<p><b>30 jours</b> après réception pour changer d’avis</p><p><b>Remboursé</b> si le mug revient inutilisé, dans son emballage (hygiène)</p><p><b>En plus</b> de vos 14 jours de rétractation et de la garantie légale de 2 ans</p><p><a href="${pageUrl('retours-et-remboursements')}">Conditions de retour</a> · <a href="${pageUrl('withdrawal')}">Se rétracter du contrat</a></p>`],
    ['🛡️ Sécurité', '<p>Posez le mug sur une surface stable et résistante à la chaleur, ne laissez jamais la bougie allumée sans surveillance, tenez hors de portée des enfants et ne déplacez pas le mug quand la bougie est allumée.</p>']
  ];

  const FAQ = [
    ['Peut-on vraiment y mettre une bougie ?', 'Oui, le logement est prévu pour ça. Posez le mug à plat et ne laissez jamais la flamme sans surveillance.'],
    ['La bougie est-elle fournie ?', 'Non. N’importe quelle bougie chauffe-plat du supermarché convient (Ø 4 cm max.).'],
    ['Est-ce que ça fait vraiment fondre le chocolat ?', 'Oui, en quelques minutes. Cassez-le en petits morceaux et remuez. Marche aussi avec caramel, pâte à tartiner ou fromage.'],
    ['Peut-on y boire un café ou un chocolat chaud ?', 'Oui, elle reste chaude pendant que vous la buvez. Ne déplacez pas le mug quand la bougie est allumée.'],
    ['Comment le nettoyer ?', 'Une fois refroidi, à la main à l’eau savonneuse. Pas de lave-vaisselle ni de micro-ondes.'],
    ['Quand vais-je recevoir ma commande ?', 'Préparée sous environ 1 à 2 jours ouvrés puis expédiée en livraison suivie (environ 6 à 9 jours ouvrés) : vous recevez le numéro de suivi par e-mail. La livraison est offerte en France dès 1 mug.'],
    ['Et s’il ne me plaît pas ?', `Vous avez 30 jours pour nous le renvoyer, inutilisé et dans son emballage : on vous rembourse (<a href="${pageUrl('retours-et-remboursements')}">conditions</a>).`]
  ];

  // ---------- Code promo mis en avant (MUG10 : -10 % sur la commande, cumulable avec les packs) ----------
  const PROMO = { code: ((MF && MF.promo && MF.promo.code) || 'MUG10').toUpperCase(), text: (MF && MF.promo && MF.promo.text) || '-10 %' };
  PROMO.rate = (parseFloat(String(PROMO.text).replace(',', '.').replace(/[^\d.]/g, '')) || 0) / 100;
  let promoOn = false;
  try { promoOn = localStorage.getItem('mf-promo') === PROMO.code; } catch (e) {}
  const withPromo = n => Math.round(n * (1 - PROMO.rate) * 100) / 100;
  const couponHtml = () => !PROMO.code ? '' : `<div class="coupon${promoOn ? ' on' : ''}" data-coupon>
      <span class="coupon-ico" aria-hidden="true">🎁</span>
      <div><b>${PROMO.text} en plus avec le code <span class="coupon-code">${PROMO.code}</span></b><small>${promoOn ? 'Code appliqué : la remise est déduite au paiement.' : 'Cumulable avec les offres de pack.'}</small></div>
      <button type="button" data-coupon-apply aria-pressed="${promoOn}">${promoOn ? '✓ Appliqué' : 'Appliquer'}</button>
    </div>`;

  const WORDS = ['🍫 CHOCOLAT', '🍓 FRAISES', '🍮 CARAMEL', '🧀 FROMAGE', '☕ CAFÉ', '🍡 GUIMAUVES', '🕯️ BOUGIE'];
  const CHEV = '<svg class="chev" viewBox="0 0 14 8" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m1 1 6 6 6-6"/></svg>';
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="10"/><path d="m7.5 12.5 3 3 6-7"/></svg>';

  // ---------- Bandeaux ----------
  $$('[data-repeat]').forEach(el => {
    const items = el.dataset.repeat.split('|');
    const one = Array.from({ length: 8 }, () => items.map(t => `<span>${t}</span>`).join('')).join('');
    el.innerHTML = one + one;
  });
  $$('[data-words]').forEach(el => {
    const one = WORDS.map(w => `<span class="word">${w}</span>`).join('');
    el.innerHTML = one + one + one + one;
  });

  // ---------- Bloc produit (accueil + page produit) ----------
  let selectedPack = PRODUCT.packs[0];
  let selectedColor = PRODUCT.colors[0];
  const syncSticky = () => {
    const sp = $('#stickyPrice'), si = $('#stickyImg');
    if (sp) sp.textContent = `${euro(selectedPack.price)} · ${selectedColor.name}`;
    if (si) si.src = img(PRODUCT.images[selectedColor.img]);
  };
  $$('[data-product]').forEach((root, idx) => {
    const H = root.dataset.product;
    const title = H === 'h2' ? `<a href="${productUrl}">${PRODUCT.title}</a>` : PRODUCT.title;
    root.innerHTML = `
      <div class="product-grid">
        <div>
          <div class="gallery-main">
            <img src="${img(PRODUCT.images[0])}" alt="${PRODUCT.title}" data-main>
            <button class="gallery-nav prev" aria-label="Précédent">‹</button>
            <button class="gallery-nav next" aria-label="Suivant">›</button>
            <span class="gallery-counter" data-counter>1 / ${PRODUCT.images.length}</span>
          </div>
          <div class="thumbs">${PRODUCT.images.map((s, i) => `<button class="${i ? '' : 'active'}" data-i="${i}" aria-label="Photo ${i + 1}"><img src="${img(s)}" alt=""></button>`).join('')}</div>
        </div>
        <div class="product-info" id="offers">
          <p class="ribbon">LE PRODUIT VIRAL · IDÉE CADEAU</p>
          <${H}>${title}</${H}>
          <div class="product-rating">Céramique émaillée · chauffé à la bougie · contenance ≈ 130 ml</div>
          <ul class="checks">
            <li>${CHECK} Chocolat fondu en 3 minutes</li>
            <li>${CHECK} Sans casserole, sans fil ni prise</li>
            <li>${CHECK} Satisfait ou remboursé 30 jours</li>
          </ul>
          <p class="packs-title">COULEUR : <span data-color-name>${PRODUCT.colors[0].name}</span></p>
          <div class="colors">${PRODUCT.colors.map((c, i) => `
            <button class="color ${i ? '' : 'selected'}" data-color="${i}" aria-label="${c.name}"><i style="background:${c.hex}"></i>${c.name}</button>`).join('')}
          </div>
          <p class="packs-title">CHOISISSEZ VOTRE OFFRE</p>
          <div class="packs">${PRODUCT.packs.map((p, i) => `
            <label class="pack ${i ? '' : 'selected'}" data-pack="${p.id}">
              ${p.badge ? `<span class="pack-badge">${p.badge}</span>` : ''}
              <input type="radio" name="pack-${idx}" value="${p.id}" ${i ? '' : 'checked'}>
              <span class="pack-txt"><strong>${p.emoji} ${p.name}${p.full ? `<span class="save">-${euro(p.full - p.price)}</span>` : ''}</strong><small>${p.sub}</small></span>
              <span class="pack-price"><strong>${euro(p.price)}</strong>${p.qty > 1 ? `<em>soit ${euro(p.price / p.qty)} / mug</em><em>Économisez ${euro(p.full - p.price)}</em>` : ''}</span>
            </label>`).join('')}
          </div>
          <p class="pack-note">Cliquez sur une offre pour choisir la couleur de chaque mug. La remise du pack s’applique automatiquement au panier.</p>
          ${couponHtml()}
          <button class="btn full beige" data-add>Ajouter au panier</button>
          <div class="trust-row"><span>🚚 Livraison offerte</span><span>🔒 Paiement sécurisé</span><span>↩️ Satisfait ou remboursé</span></div>
          <details class="acc">
            <summary>✨ Utilisation Recommandée ${CHEV}</summary>
            <div class="acc-body">${STEPS.map((s, i) => `<p><b>Étape ${i + 1} : ${s.t}</b><br>${s.d}</p>`).join('')}<p><small>Ne laissez jamais la flamme sans surveillance.</small></p></div>
          </details>
          ${INFOS.map(([t, c]) => `<details class="acc"><summary>${t} ${CHEV}</summary><div class="acc-body">${c}</div></details>`).join('')}
          ${H === 'h2' ? `<a href="${productUrl}" class="details-link">Afficher tous les détails →</a>` : ''}
        </div>
      </div>`;

    let cur = 0;
    const main = $('[data-main]', root), counter = $('[data-counter]', root), thumbs = $$('.thumbs button', root);
    const show = i => {
      cur = (i + PRODUCT.images.length) % PRODUCT.images.length;
      main.src = img(PRODUCT.images[cur]);
      counter.textContent = `${cur + 1} / ${PRODUCT.images.length}`;
      thumbs.forEach((t, j) => t.classList.toggle('active', j === cur));
    };
    thumbs.forEach(t => t.onclick = () => show(+t.dataset.i));
    $('.prev', root).onclick = () => show(cur - 1);
    $('.next', root).onclick = () => show(cur + 1);
    let x0 = null;
    main.parentElement.addEventListener('touchstart', e => x0 = e.touches[0].clientX, { passive: true });
    main.parentElement.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    $$('.color', root).forEach(b => b.addEventListener('click', () => {
      $$('.color', root).forEach(x => x.classList.remove('selected'));
      b.classList.add('selected');
      selectedColor = PRODUCT.colors[+b.dataset.color];
      $('[data-color-name]', root).textContent = selectedColor.name;
      show(selectedColor.img);
      syncSticky();
    }));
    // un clic sur une offre la sélectionne et ouvre la fenêtre « Votre offre » (comme sur le site d'origine)
    $$('.pack', root).forEach(el => el.addEventListener('click', e => {
      e.preventDefault();
      selectPack(root, el.dataset.pack);
      quickBuy.open(PRODUCT.packs.findIndex(p => p.id === el.dataset.pack));
    }));
    $('[data-add]', root).onclick = e => {
      const p = PRODUCT.packs.find(p => p.id === $('.pack.selected', root).dataset.pack);
      const c = PRODUCT.colors[+$('.color.selected', root).dataset.color];
      addToCart([{ color: c, qty: p.qty }], e.currentTarget);
    };
  });
  function selectPack(root, id) {
    $$('.pack', root).forEach(p => { const on = p.dataset.pack === id; p.classList.toggle('selected', on); $('input', p).checked = on; });
    selectedPack = PRODUCT.packs.find(p => p.id === id);
    syncSticky();
  }

  // ---------- Fenêtre « Votre offre » (reprise de mugfondue-quick.js du thème Qavelynt) ----------
  const quickBuy = (() => {
    const TRUST = ['Livraison suivie', 'Satisfait ou remboursé', 'Paiement sécurisé', 'Boutique française'];
    const LOCK = '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><rect x="3" y="7" width="10" height="7.5" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    let box, panel, body, sel = 0, picks = [], im = 0, last = null, isOpen = false;
    const build = () => {
      box = document.createElement('div');
      box.className = 'qb'; box.hidden = true;
      box.innerHTML = '<div class="qb-scrim" data-qb-close></div><div class="qb-panel" role="dialog" aria-modal="true" aria-labelledby="qb-title" tabindex="-1"><div class="qb-grab" aria-hidden="true"></div>' +
        '<button type="button" class="qb-x" data-qb-close aria-label="Fermer"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="qb-body"></div></div>';
      document.body.appendChild(box);
      panel = $('.qb-panel', box); body = $('.qb-body', box);
      box.addEventListener('click', e => {
        if (e.target.closest('[data-qb-close]')) return close();
        const t = e.target.closest('[data-qb-img]');
        if (t) { im = +t.dataset.qbImg; return drawMedia(); }
        const p = e.target.closest('[data-qb-pack]');
        if (p) { sel = +p.dataset.qbPack; syncPicks(); $$('[data-product]').forEach(r => selectPack(r, PRODUCT.packs[sel].id)); return drawInfo(); }
        const g = e.target.closest('[data-qb-go]');
        if (g) go(g.dataset.qbGo === 'pay', g);
      });
      box.addEventListener('change', e => {
        const m = e.target.dataset.qbMug;
        if (m == null) return;
        picks[+m] = +e.target.value;
        if (+m === 0) { im = PRODUCT.colors[picks[0]].img; drawMedia(); }
      });
      box.addEventListener('keydown', e => {
        if (e.key === 'Escape') return close();
        if (e.key !== 'Tab') return;
        const f = $$('button:not([disabled]),input:not([disabled]),a[href]', panel).filter(el => el.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    };
    // garde les coloris déjà choisis quand on change d'offre
    const syncPicks = () => {
      const def = PRODUCT.colors.indexOf(selectedColor);
      picks = Array.from({ length: PRODUCT.packs[sel].qty }, (_, i) => picks[i] != null ? picks[i] : def);
    };
    const drawMedia = () => {
      const m = $('.qb-media', body);
      m.innerHTML = `<div class="qb-main"><img src="${img(PRODUCT.images[im])}" alt="Le Mug Fondue, photo ${im + 1}"></div>` +
        `<div class="qb-thumbs">${PRODUCT.images.map((s, i) => `<button type="button" data-qb-img="${i}" class="${i === im ? 'is-on' : ''}" aria-label="Voir la photo ${i + 1}"><img src="${img(s)}" alt=""></button>`).join('')}</div>`;
    };
    const drawInfo = () => {
      const o = PRODUCT.packs[sel];
      const mugs = picks.map((pk, i) => `<div class="qb-mug" role="radiogroup" aria-label="Coloris du mug ${i + 1}"><span>${o.qty > 1 ? 'Mug ' + (i + 1) : 'Coloris'}</span><div class="qb-chips">` +
        PRODUCT.colors.map((c, ci) => `<label class="qb-chip"><input type="radio" name="qb-mug-${i}" data-qb-mug="${i}" value="${ci}"${pk === ci ? ' checked' : ''}><span style="--sw:${c.hex}">${c.name}</span></label>`).join('') + '</div></div>').join('');
      $('.qb-info', body).innerHTML =
        `<p class="qb-kicker">Votre offre</p><h2 class="qb-title" id="qb-title">${o.name}</h2>` +
        `<div class="qb-packs" role="group" aria-label="Choisir une offre">${PRODUCT.packs.map((p, i) => `<button type="button" class="qb-pack" data-qb-pack="${i}" aria-pressed="${i === sel}">${p.badge ? `<i>${p.badge}</i>` : ''}<b>${p.name.split('·')[0].trim()}</b><span>${euro(p.price).replace('€', ' EUR')}</span></button>`).join('')}</div>` +
        `<div class="qb-price"><strong>${euro(o.price).replace('€', ' EUR')}</strong>${o.qty > 1 ? `<small>soit ${euro(o.price / o.qty).replace('€', ' EUR')} / mug</small><em class="qb-save">Économisez ${euro(o.full - o.price).replace('€', ' EUR')}</em>` : ''}</div>` +
        (promoOn && PROMO.rate ? `<p class="qb-promo-price">Avec le code ${PROMO.code} : <b>${euro(withPromo(o.price)).replace('€', ' EUR')}</b></p>` : '') +
        `<p class="qb-sub">${o.sub}</p><div class="qb-colors">${mugs}</div>` + couponHtml() +
        `<div class="qb-btns"><button type="button" class="btn full" data-qb-go="cart">Ajouter au panier<span class="qb-only-desk">&nbsp;· ${euro(o.price).replace('€', ' EUR')}</span></button>` +
        `<button type="button" class="btn full qb-red" data-qb-go="pay">${LOCK}Acheter maintenant</button></div>` +
        `<p class="qb-note">En cliquant sur « Acheter maintenant », vous acceptez nos <a href="${pageUrl('conditions-generales-de-vente')}">CGV</a>.</p>` +
        `<ul class="qb-trust">${TRUST.map(t => `<li>${t}</li>`).join('')}</ul>`;
    };
    const open = i => {
      if (!box) build();
      sel = Math.max(0, i); im = 0; picks = []; syncPicks();
      last = document.activeElement;
      body.innerHTML = '<div class="qb-media"></div><div class="qb-info"></div>';
      drawMedia(); drawInfo();
      box.hidden = false; isOpen = true;
      document.documentElement.classList.add('qb-lock');
      void box.offsetWidth;
      box.classList.add('is-open'); panel.focus({ preventScroll: true });
    };
    const close = keep => {
      if (!isOpen) return;
      isOpen = false; box.classList.remove('is-open');
      document.documentElement.classList.remove('qb-lock');
      setTimeout(() => { if (!isOpen) box.hidden = true; }, 320);
      if (keep !== true && last && last.focus) last.focus({ preventScroll: true });
    };
    // regroupe les mugs par coloris, puis ajoute au panier ou part directement au paiement
    const go = (pay, btn) => {
      const by = {};
      picks.forEach(ci => { by[ci] = (by[ci] || 0) + 1; });
      const lines = Object.keys(by).map(ci => ({ color: PRODUCT.colors[ci], qty: by[ci] }));
      if (pay) {
        btn.disabled = true;
        cartApi.add(lines).then(() => cartApi.checkout(promoOn ? PROMO.code : '')).catch(err => { btn.disabled = false; toast((err && err.description) || 'Impossible de passer au paiement, réessayez.'); });
      } else {
        close(true);
        addToCart(lines, null);
      }
    };
    return { open, close, redraw: () => { if (isOpen) drawInfo(); } };
  })();

  // ---------- Slider vidéo (repris de mugfondue.js du thème Qavelynt) ----------
  $$('[data-vslider]').forEach(s => {
    const row = $('[data-videos]', s);
    const go = d => row.scrollBy({ left: d * Math.min(380, row.clientWidth * .8), behavior: 'smooth' });
    let timer = null, held = false;
    // défilement auto : une vidéo toutes les 3,5 s, retour au début à la fin, en pause au survol / au toucher
    const tick = () => {
      if (held || document.hidden || !s.offsetParent) return;
      if (row.scrollLeft >= row.scrollWidth - row.clientWidth - 8) row.scrollTo({ left: 0, behavior: 'smooth' });
      else go(1);
    };
    const restart = () => { clearInterval(timer); timer = setInterval(tick, 3500); };
    $('[data-vid-prev]', s).addEventListener('click', () => { go(-1); restart(); });
    $('[data-vid-next]', s).addEventListener('click', () => { go(1); restart(); });
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      restart();
      row.addEventListener('pointerenter', () => { held = true; });
      row.addEventListener('pointerleave', () => { held = false; });
      row.addEventListener('touchstart', () => { held = true; }, { passive: true });
      row.addEventListener('touchend', () => { setTimeout(() => { held = false; restart(); }, 4000); }, { passive: true });
    }
  });

  // ---------- FAQ ----------
  $$('[data-faq]').forEach(el => {
    el.innerHTML = FAQ.map(([q, a]) => `<details class="faq-item"><summary>${q} ${CHEV}</summary><div class="ans">${a}</div></details>`).join('');
  });

  // ---------- Panier ----------
  const openCart = () => { $('#drawer').classList.add('open'); $('#overlay').classList.add('open'); };
  const closeAll = () => ['#drawer', '#overlay', '#mnav'].forEach(s => $(s) && $(s).classList.remove('open'));
  const setCount = n => { $('#cartCount').textContent = n; $('#cartCount').classList.toggle('show', n > 0); };
  const emptyCart = () => {
    $('#cartFoot').style.display = 'none';
    $('#cartItems').innerHTML = '<div class="cart-empty"><p>Votre panier est vide</p><button class="btn" data-close>Continuer les achats</button></div>';
    $('#cartItems [data-close]').onclick = closeAll;
  };
  const lineHtml = (key, image, name, sub, qty, price, note) => `<div class="line"><img src="${image}" alt="">
    <div><h5>${name}</h5><small>${sub}</small>${note ? `<br><small class="ok">${note}</small>` : ''}<br>
      <span class="qty"><button data-dec="${key}" aria-label="Retirer un">−</button><span>${qty}</span><button data-inc="${key}" aria-label="Ajouter un">+</button></span>
      <br><button class="rm" data-rm="${key}">Supprimer</button></div>
    <strong>${price}</strong></div>`;
  // Prix d'un nombre de mugs avec les remises automatiques de la boutique (2+ : -7 €, 4+ : -31 €)
  const bundlePrice = n => n * 17 - (n >= 4 ? 31 : n >= 2 ? 7 : 0);

  let cartApi;
  if (MF) {
    // --- Mode Shopify : panier réel ---
    let state = null;
    const req = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));
    const render = c => {
      state = c;
      setCount(c.item_count);
      if (!c.item_count) return emptyCart();
      $('#cartFoot').style.display = '';
      $('#cartItems').innerHTML = c.items.map(it => lineHtml(it.key, it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=200' : img(PRODUCT.images[0]), it.product_title, it.variant_title || '', it.quantity,
        euro(it.final_line_price / 100) + (it.final_line_price < it.original_line_price ? `<br><s>${euro(it.original_line_price / 100)}</s>` : ''), '')).join('');
      // remises : packs (par ligne) + code promo (sur la commande)
      const rows = {};
      c.items.forEach(i => i.line_level_discount_allocations.forEach(a => { rows[a.discount_application.title] = (rows[a.discount_application.title] || 0) + a.amount; }));
      (c.cart_level_discount_applications || []).forEach(d => { rows[d.title] = (rows[d.title] || 0) + d.total_allocated_amount; });
      $('#cartDiscount').innerHTML = Object.keys(rows).map(t => `<div><span>${t}</span><span>−${euro(rows[t] / 100)}</span></div>`).join('');
      $('#subtotal').textContent = euro(c.total_price / 100) + ' EUR';
      const applied = (c.discount_codes || []).some(d => String(d.code).toUpperCase() === PROMO.code && d.applicable !== false);
      if (c.discount_codes && applied !== promoOn) setPromoState(applied);
      const change = (key, q) => req(MF.routes.change, { id: key, quantity: q }).then(render);
      $$('[data-inc]').forEach(b => b.onclick = () => change(b.dataset.inc, state.items.find(i => i.key === b.dataset.inc).quantity + 1));
      $$('[data-dec]').forEach(b => b.onclick = () => change(b.dataset.dec, state.items.find(i => i.key === b.dataset.dec).quantity - 1));
      $$('[data-rm]').forEach(b => b.onclick = () => change(b.dataset.rm, 0));
    };
    cartApi = {
      refresh: () => req(MF.routes.cartJs).then(render),
      add: lines => req(MF.routes.add, { items: lines.map(l => ({ id: l.color.variant, quantity: l.qty })) }).then(() => cartApi.refresh()),
      // le code est posé sur le panier Shopify (API panier) ; il est aussi repassé à l'ouverture du paiement
      promo: on => req(MF.routes.update, { discount: on ? PROMO.code : '' }).then(render).catch(() => cartApi.refresh()),
      checkout: code => { location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); }
    };
  } else {
    // --- Mode fichier HTML : panier local, paiement sur qavelynt.com ---
    let cart = [];
    try { cart = JSON.parse(localStorage.getItem('mugfondue-cart') || '[]'); } catch (e) { cart = []; }
    const save = () => { try { localStorage.setItem('mugfondue-cart', JSON.stringify(cart)); } catch (e) {} };
    const colorOf = n => PRODUCT.colors.find(x => x.name === n) || PRODUCT.colors[0];
    const render = () => {
      cart = cart.filter(l => l.color && l.qty > 0);
      const n = cart.reduce((s, l) => s + l.qty, 0);
      setCount(n);
      if (!n) return emptyCart();
      $('#cartFoot').style.display = '';
      $('#cartItems').innerHTML = cart.map(l => lineHtml(l.color, img(PRODUCT.images[colorOf(l.color).img]), PRODUCT.title, l.color, l.qty, euro(17 * l.qty), '')).join('');
      const disc = n * 17 - bundlePrice(n);
      const promoOff = promoOn ? Math.round((bundlePrice(n) - withPromo(bundlePrice(n))) * 100) / 100 : 0;
      $('#cartDiscount').innerHTML = (disc ? `<div><span>${n >= 4 ? 'Mug Fondue — 4 mugs à 37 €' : 'Mug Fondue — 2 mugs à 27 €'}</span><span>−${euro(disc)}</span></div>` : '') +
        (promoOff ? `<div><span>Code ${PROMO.code} (${PROMO.text})</span><span>−${euro(promoOff)}</span></div>` : '');
      $('#subtotal').textContent = euro(bundlePrice(n) - promoOff) + ' EUR';
      const upd = (k, d) => { const l = cart.find(x => x.color === k); l.qty = d === 0 ? 0 : l.qty + d; save(); render(); };
      $$('[data-inc]').forEach(b => b.onclick = () => upd(b.dataset.inc, 1));
      $$('[data-dec]').forEach(b => b.onclick = () => upd(b.dataset.dec, -1));
      $$('[data-rm]').forEach(b => b.onclick = () => upd(b.dataset.rm, 0));
    };
    cartApi = {
      refresh: () => Promise.resolve(render()),
      add: lines => {
        lines.forEach(({ color, qty }) => { const l = cart.find(x => x.color === color.name); l ? l.qty += qty : cart.push({ color: color.name, qty }); });
        save(); return Promise.resolve(render());
      },
      promo: () => Promise.resolve(render()),
      // Lien panier Shopify : crée le panier sur la boutique et ouvre directement le paiement
      checkout: code => {
        const items = cart.map(l => `${colorOf(l.color).variant}:${l.qty}`).join(',');
        window.location.href = `${STORE}/cart/${items}${code ? '?discount=' + encodeURIComponent(code) : ''}`;
      }
    };
  }

  function addToCart(lines, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Ajout…'; }
    cartApi.add(lines).then(openCart).catch(err => toast((err && err.description) || 'Impossible d’ajouter au panier, réessayez.'))
      .finally(() => { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
  }
  $$('[data-open-cart]').forEach(b => b.onclick = e => { e.preventDefault(); openCart(); });
  $$('[data-close]').forEach(b => b.onclick = closeAll);
  $('#overlay').onclick = closeAll;
  $$('[data-open-menu]').forEach(b => b.onclick = () => { $('#mnav').classList.add('open'); $('#overlay').classList.add('open'); });
  $$('#mnav a').forEach(a => a.addEventListener('click', closeAll));
  // état du code promo : encarts (offres, fenêtre, panier) redessinés partout d'un coup
  function setPromoState(on) {
    promoOn = on;
    try { on ? localStorage.setItem('mf-promo', PROMO.code) : localStorage.removeItem('mf-promo'); } catch (e) {}
    $$('[data-coupon]').forEach(el => { el.outerHTML = couponHtml(); });
    const cc = $('#cartCoupon'); if (cc) cc.innerHTML = couponHtml();
    quickBuy.redraw();
  }
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-coupon-apply]')) return;
    const on = !promoOn;
    setPromoState(on);
    cartApi.promo(on);
    toast(on ? `Code ${PROMO.code} appliqué : ${PROMO.text} au paiement 🎁` : `Code ${PROMO.code} retiré.`);
  });
  if ($('#cartCoupon')) $('#cartCoupon').innerHTML = couponHtml();
  $('#promoBtn').onclick = () => {
    const code = $('#promoInput').value.trim().toUpperCase();
    if (code === PROMO.code) { $('#promoInput').value = ''; if (!promoOn) { setPromoState(true); cartApi.promo(true); } $('#promoMsg').textContent = `Code ${PROMO.code} appliqué.`; return; }
    $('#promoMsg').textContent = code ? `Le code ${code} sera appliqué à l’étape du paiement.` : 'Entrez un code promo.';
  };
  $('#checkout').onclick = () => {
    if (!$('#tos').checked) { $('#tosWrap').classList.add('err'); toast('Cochez la case pour accepter les CGV.'); return; }
    $('#tosWrap').classList.remove('err');
    cartApi.checkout($('#promoInput').value.trim().toUpperCase() || (promoOn ? PROMO.code : ''));
  };
  const stickyBtn = $('[data-sticky-add]');
  if (stickyBtn) stickyBtn.onclick = () => quickBuy.open(PRODUCT.packs.indexOf(selectedPack));
  cartApi.refresh().catch(() => {});

  // ---------- Divers ----------
  function toast(msg) {
    const t = $('#toast'); t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 3000);
  }
  // Formulaires du fichier HTML : ouverture de la messagerie vers l'adresse de la boutique
  $$('[data-mail-form]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const body = $$('input,textarea', f).filter(i => i.value && i.type !== 'checkbox').map(i => `${i.placeholder || i.name} : ${i.value}`).join('\n');
    window.location.href = `mailto:contact.pro.direction@gmail.com?subject=${encodeURIComponent(f.dataset.mailForm)}&body=${encodeURIComponent(body)}`;
  }));
  $$('[data-scroll-buy]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); $('.view.active [data-add]').scrollIntoView({ behavior: 'smooth', block: 'center' }); }));

  // ---------- Navigation du fichier HTML (#/ , #/produit , #/page/<handle>) ----------
  if (!MF) {
    const PAGES = window.MF_PAGES || {};
    const FORMS = {
      contact: ['Message depuis le site', '<input placeholder="Nom" required><input type="email" placeholder="E-mail" required><textarea placeholder="Message" required></textarea><button class="btn full">Envoyer</button>'],
      withdrawal: ['Rétractation', '<input placeholder="Nom et prénom" required><input type="email" placeholder="E-mail utilisé pour la commande" required><input placeholder="Numéro de commande" required><input placeholder="Date de réception (jj/mm/aaaa)"><textarea placeholder="Produits concernés (toute la commande, ou précisez)" required></textarea><button class="btn full">Confirmer la rétractation</button>']
    };
    const route = () => {
      const parts = decodeURIComponent(location.hash.replace(/^#\/?/, '')).split('/');
      let view = parts[0] || 'accueil';
      if (view === 'page') {
        const pg = PAGES[parts[1]];
        if (!pg) view = 'accueil';
        else {
          const form = FORMS[parts[1]];
          $('#pageTitle').textContent = pg.title;
          $('#pageBody').innerHTML = pg.body + (form ? `<form class="page-form" data-mail-form="${form[0]}">${form[1]}<p class="muted">Le bouton ouvre votre messagerie avec un e-mail prêt à envoyer à contact.pro.direction@gmail.com.</p></form>` : '');
          $$('#pageBody [data-mail-form]').forEach(f => f.addEventListener('submit', e => {
            e.preventDefault();
            const body = $$('input,textarea', f).filter(i => i.value).map(i => `${i.placeholder} : ${i.value}`).join('\n');
            window.location.href = `mailto:contact.pro.direction@gmail.com?subject=${encodeURIComponent(f.dataset.mailForm)}&body=${encodeURIComponent(body)}`;
          }));
        }
      }
      if (!$(`[data-view="${view}"]`)) view = 'accueil';
      $$('[data-view]').forEach(v => v.classList.toggle('active', v.dataset.view === view));
      $$('.nav a').forEach(a => a.classList.toggle('current', a.getAttribute('href') === location.hash));
      $('.faq').style.display = (view === 'accueil' || view === 'produit') ? '' : 'none';
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', route);
    route();
    $$('[data-search]').forEach(b => b.onclick = () => { location.hash = '#/produit'; });
  }
  $$('[data-goto-faq]').forEach(a => a.addEventListener('click', () => setTimeout(() => $('.faq').scrollIntoView({ behavior: 'smooth' }), 60)));

  // Barre collante : visible quand le bouton du produit sort de l'écran
  const sticky = $('#stickyAtc');
  if (sticky) window.addEventListener('scroll', () => {
    const btn = $('.view.active [data-add]');
    if (!btn) return sticky.classList.remove('show');
    const r = btn.getBoundingClientRect();
    sticky.classList.toggle('show', r.bottom < 0 || r.top > innerHeight);
  }, { passive: true });
})();
